import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import BaseCheckbox from '../../../../shared/ui/BaseCheckbox';
import { useSetParentRoom } from '../../ParentRoomProvider';
import { ReactComponent as LinkIcon } from '../../../../../../resource/LinkAngleRight.svg';
import { actionCreators, selectors, sliceKeys } from '../../../../model';
import styles from './index.module.scss';

const { createIsRoomExcludedSelector } = selectors[sliceKeys.houses];

const { roomExcludeClicked } = actionCreators[sliceKeys.houses];

const Action = ({ room, hasRelations }) => {
  const { isRelatedAddresses } = room;

  const selectIsExcluded = useMemo(
    () => createIsRoomExcludedSelector(room.houseId, room.id),
    [room.houseId, room.id]
  );

  const excluded = useSelector(selectIsExcluded);

  const canRelated = isRelatedAddresses && !hasRelations && !excluded;

  return (
    <div className={styles.root}>
      {canRelated && <SetupRelation room={room} />}
      <ToggleExclusion room={room} excluded={excluded} />
    </div>
  );
};

export default Action;

function SetupRelation({ room }) {
  const setParentRoom = useSetParentRoom();

  return (
    <Tooltip title="Настроить связи">
      <Button
        shape="circle-outline"
        className={styles.setupRelation}
        onClick={() => setParentRoom(room)}
      >
        <Icon component={LinkIcon} />
      </Button>
    </Tooltip>
  );
}

function ToggleExclusion({ room, excluded }) {
  const dispatch = useDispatch();

  const checked = !excluded;

  const handleChange = () => {
    dispatch(roomExcludeClicked(room, !checked));
  };

  return (
    <Tooltip
      title={
        excluded
          ? 'Включить помещение в приемку'
          : 'Исключить помещение из приемки'
      }
    >
      <BaseCheckbox checked={checked} onChange={handleChange} />
    </Tooltip>
  );
}
